import project1_mob1x from '../images/projects/image_1_mob@1x.webp';
import project1_mob2x from '../images/projects/image_1_mob@2x.webp';
import project1_tab1x from '../images/projects/image_1_tab_desk@1x.webp';
import project1_tab2x from '../images/projects/image_1_tab_desk@2x.webp';
import project2_mob1x from '../images/projects/image_2_mob@1x.webp';
import project2_mob2x from '../images/projects/image_2_mob@2x.webp';
import project2_tab1x from '../images/projects/image_2_tab_desk@1x.webp';
import project2_tab2x from '../images/projects/image_2_tab_desk@2x.webp';
import project3_mob1x from '../images/projects/image_3_mob@1x.webp';
import project3_mob2x from '../images/projects/image_3_mob@2x.webp';
import project3_tab1x from '../images/projects/image_3_tab_desk@1x.webp';
import project3_tab2x from '../images/projects/image_3_tab_desk@2x.webp';

export const projectsImages = {
  project1_mob1x,
  project1_mob2x,
  project1_tab1x,
  project1_tab2x,
  project2_mob1x,
  project2_mob2x,
  project2_tab1x,
  project2_tab2x,
  project3_mob1x,
  project3_mob2x,
  project3_tab1x,
  project3_tab2x,
};
